export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5371.94387f68.jpg";